export default __webpack_public_path__ + "static/media/ml.ec2e5dc7.svg";